<template>
  <b-row>
    <!-- Modal Filter -->
    <b-modal
      v-model="showModalFilter"
      title="Modal Filter"
      ok-title="Apply Filter"
      @ok="activeTab === 'active' ? fetchCustomers() : fetchCustomerProspects()"
    >
      <b-form-group label="Used For" label-for="fleet" label-cols="3">
        <v-select
          v-model="
            activeTab === 'active'
              ? equipment.params.vehicleTypeIds
              : equipment.prospectParams.vehicleTypeIds
          "
          id="fleet"
          multiple
          placeholder="Select Vehicle Type"
          label="name"
          :options="typeFleet"
          :reduce="(opt) => opt.code"
        ></v-select>
      </b-form-group>
      <b-form-group
        label="Status"
        label-for="active"
        label-cols="3"
        class="mb-0"
      >
        <b-form-checkbox
          v-model="equipment.params.active"
          name="check-button"
          switch
          inline
        >
          <template v-if="equipment.params.active === false">No</template>
          <template v-else>Yes</template>
        </b-form-checkbox>
      </b-form-group>
    </b-modal>

    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExport"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <b-col sm="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary">
            <strong>Costumer</strong>
          </h4>
        </template>

        <template v-slot:body>
          <div class="mb-4">
            <CustomNav :items="tabs" @item-click="(tab) => (activeTab = tab)" />
          </div>
          <div class="d-flex justify-content-between">
            <b-form
              class="d-flex mb-3"
              @submit.prevent="
                activeTab === 'active'
                  ? fetchCustomers()
                  : fetchCustomerProspects()
              "
            >
              <b-form-input
                v-if="activeTab === 'prospect'"
                v-model="equipment.prospectParams.search"
                style="width: 200px"
                type="text"
                class="mr-2"
                placeholder="Search..."
                @input="handleSearchInput"
              ></b-form-input>
              <b-form-input
                v-if="activeTab === 'active'"
                v-model="equipment.params.search"
                style="width: 200px"
                type="text"
                class="mr-2"
                placeholder="Search..."
                @input="handleSearchInput"
              ></b-form-input>
              <b-button type="submit" variant="primary" class="ml-2" :disabled="isLoading">
                <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                <i v-else class="fa fa-search"></i>
                <span v-if="isLoading">Loading...</span>
              </b-button>
              <div>
                <b-button
                  type="button"
                  variant="outline-primary"
                  class="ml-2"
                  @click="showModalFilter = true"
                >
                  <i class="fa fa-sliders"></i>
                  Filter Data
                </b-button>
              </div>
            </b-form>
            <div class="d-flex">
              <b-button
                variant="outline-primary"
                style="height: max-content"
                class="mr-2 d-flex align-items-center"
                @click="exportData"
              >
                <i class="ri-upload-2-line pl-1"></i>
                Export
              </b-button>
              <template v-if="activeTab == 'prospect'">
                <b-button
                  variant="outline-primary"
                  class="d-flex align-items-center mr-2"
                  style="height: max-content"
                  @click="showModalImport = true"
                >
                  <i class="ri-download-2-line pl-1"></i>
                  Import
                </b-button>
                <b-button
                  variant="primary"
                  @click="openSidebar()"
                  style="height: max-content"
                >
                  <i class="fa fa-plus mr-1"></i>
                  New Customer Prospect
                </b-button>
              </template>
            </div>
          </div>

          <!-- List -->
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-light">
                <tr>
                  <th v-if="activeTab == 'active'" class="text-nowrap column-1">
                    Customer Id
                  </th>
                  <th
                    class="text-nowrap column-2"
                    :style="{ left: activeTab == 'active' ? '160px' : '0px' }"
                  >
                    Customer Name
                  </th>
                  <th class="text-nowrap">Customer Class</th>
                  <th class="text-nowrap" v-if="activeTab == 'active'">
                    Currency
                  </th>
                  <th class="text-nowrap" v-if="activeTab == 'active'">
                    Terms
                  </th>
                  <th class="text-nowrap">Job Title</th>
                  <th class="text-nowrap">Pic No. Handphone</th>
                  <th class="text-nowrap">Pic Email</th>
                  <th class="text-nowrap">Country</th>
                  <th class="text-nowrap">City</th>
                  <th class="text-nowrap" style="width: 240px; max-width: 240px;">Address</th>
                  <th class="text-center text-nowrap" style="min-width: 100px">
                    Status
                  </th>
                  <th class="text-center text-nowrap column-action">Action</th>
                </tr>
              </thead>
              <!-- Loading Spinner -->
              <tbody v-if="isLoading">
                <tr>
                  <td :colspan="activeTab === 'active' ? 11 : 10" class="text-center py-5">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    <div class="mt-2 text-muted">Loading data...</div>
                  </td>
                </tr>
              </tbody>
              <!-- Active Customer Data -->
              <tbody v-else-if="activeTab === 'active'">
                <tr
                  v-for="(item, index) in listCustomerActive"
                  :key="`a-${index}`"
                >
                  <td
                    v-if="activeTab == 'active'"
                    class="text-nowrap column-1 bg-white"
                  >
                    {{ item.customer_code }}
                  </td>
                  <td
                    class="text-nowrap column-2 bg-white"
                    :style="{ left: activeTab == 'active' ? '160px' : '0px' }"
                  >
                    {{ item.account_name }}
                  </td>
                  <td class="text-nowrap">
                    {{ item.customer_class.name || '-' }}
                  </td>
                  <td class="text-nowrap">
                    {{ item.financial?.currency?.currency || '-' }}
                  </td>
                  <td class="text-nowrap">
                    {{ item.financial?.terms?.description || '-' }}
                  </td>
                  <td class="text-nowrap">
                    {{ getContactValue(item.contact, 'job_title') }}
                  </td>
                  <td class="text-nowrap">
                    {{ getContactValue(item.contact, 'phone') }}
                  </td>
                  <td class="text-nowrap">
                    {{ getContactValue(item.contact, 'email') }}
                  </td>
                  <td class="text-nowrap">{{ item.country_id || '-' }}</td>
                  <td class="text-nowrap">{{ item.city || '-' }}</td>
                  <td 
                    class="address-column"
                    style="width: 240px; max-width: 240px;"
                    :title="item.address || '-'"
                    v-b-tooltip.hover
                  >
                    <div class="address-text">
                      {{ item.address || '-' }}
                    </div>
                  </td>
                  <td class="text-center">
                    <span
                      class="badge badge-pill"
                      :class="{
                        'badge-success': item.customer_status === 'active',
                        'badge-warning': item.customer_status === 'requested',
                        'badge-danger': item.customer_status === 'blacklist',
                      }"
                    >
                      {{ item.customer_status }}
                    </span>
                  </td>
                  <td class="text-center column-action bg-white">
                    <b-button id="popover-action" variant="primary" size="sm">
                      Action
                    </b-button>

                    <b-popover
                      target="popover-action"
                      triggers="focus"
                      placement="bottom"
                    >
                      <div class="d-flex flex-column text-left">
                        <b-button
                          variant="link"
                          class="p-0 text-dark text-left"
                          @click="
                            () => {
                              showDetailCustomer(item)
                            }
                          "
                        >
                          Detail Customer
                        </b-button>
                      </div>
                    </b-popover>
                  </td>
                </tr>
              </tbody>
              <!-- Customer Prospects Data -->
              <tbody v-else-if="!isLoading">
                <tr
                  v-for="(item, index) in listCustomerProspect"
                  :key="`p-${index}`"
                >
                  <td
                    v-if="activeTab == 'active'"
                    class="text-nowrap column-1 bg-white"
                  ></td>
                  <td
                    class="text-nowrap column-2 bg-white"
                    :style="{ left: activeTab == 'active' ? '160px' : '0px' }"
                  >
                    {{ item.account_name || item.name }}
                  </td>
                  <td class="text-nowrap">{{ item.customer_class || '-' }}</td>
                  <td class="text-nowrap">
                    {{ item.primary_job_title || '-' }}
                  </td>
                  <td class="text-nowrap">
                    {{ item.primary_mobile_phone || '-' }}
                  </td>
                  <td class="text-nowrap">{{ item.primary_email || '-' }}</td>
                  <td class="text-nowrap">
                    {{ item.country_id || item.country || '-' }}
                  </td>
                  <td class="text-nowrap">{{ item.city || '-' }}</td>
                  <td 
                    class="address-column"
                    style="width: 240px; max-width: 240px;"
                    :title="item.address || '-'"
                    v-b-tooltip.hover
                  >
                    <div class="address-text">
                      {{ item.address || '-' }}
                    </div>
                  </td>
                  <td class="text-center">
                    <span
                      class="badge badge-pill"
                      :class="{
                        'badge-success':
                          item.customer_status?.toLowerCase() === 'active',
                        'badge-warning':
                          item.customer_status?.toLowerCase() === 'requested' ||
                          item.status === 'prospect',
                        'badge-danger':
                          item.customer_status?.toLowerCase() === 'blacklist',
                      }"
                    >
                      {{ item.customer_status || item.status || 'prospect' }}
                    </span>
                  </td>
                  <td class="text-center column-action bg-white">
                    <b-button
                      :id="`popover-action-prospect-${index}`"
                      variant="primary"
                      size="sm"
                    >
                      Action
                    </b-button>

                    <b-popover
                      :ref="`popoverProspect-${index}`"
                      :target="`popover-action-prospect-${index}`"
                      triggers="focus"
                      placement="bottom"
                    >
                      <div class="d-flex flex-column text-left">
                        <b-button
                          variant="link"
                          class="p-0 text-dark text-left"
                          @click="
                            () => {
                              closeProspectPopover(index)
                              showDetailCustomer(item, true)
                            }
                          "
                        >
                          Detail Customer
                        </b-button>
                        <b-button
                          variant="link"
                          class="p-0 text-dark text-left"
                          @click="
                            () => {
                              closeProspectPopover(index)
                              openEditCustomer(item)
                            }
                          "
                        >
                          Edit Customer
                        </b-button>
                      </div>
                    </b-popover>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-4 d-flex align-items-center w-100 justify-content-end">
            <b-pagination
              class="mb-0 mr-3"
              @input="handlePageChange"
              v-model="currentPage"
              :total-rows="
                activeTab === 'active'
                  ? equipment.params.total
                  : equipment.prospectParams.total
              "
              :per-page="currentLimit"
              first-number
              align="center"
              :disabled="isLoading"
            ></b-pagination>
            <b-form-select
              plain
              v-model="currentLimit"
              :options="limitOptions"
              style="width: 140px"
              @change="handleLimitChange"
              :disabled="isLoading"
              @input="
                () =>
                  activeTab === 'active'
                    ? fetchCustomers()
                    : fetchCustomerProspects()
              "
            ></b-form-select>
          </div>
        </template>
      </iq-card>
    </b-col>

    <!-- Custom Sidebar -->
    <custom-sidebar
      v-model="showSidebar"
      size="80%"
      :title="`${equipment.editMode ? 'Edit' : 'New'} Customer ${
        activeTab === 'prospect' ? 'Prospect' : ''
      }`"
    >
      <FormCustomerNew
        v-if="showSidebar"
        :value="equipment.detailData"
        @close="showSidebar = false"
        @submitted="afterFormSubmit"
      />
    </custom-sidebar>

    <!-- Detail Sidebar -->
    <custom-sidebar v-model="showDetail" size="90%" title="Customer Detail">
      <div class="p-3 bg-white">
        <CustomNav
          :items="detailTabs"
          @item-click="(t) => (detailActiveTab = t)"
        />

        <!-- GENERAL TAB -->
        <div v-if="detailActiveTab === 'general'" class="mt-4">
          <b-row>
            <b-col md="6">
              <div class="section-title mb-3">
                <h6>ACCOUNT INFO</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Account Name</small>
                  <div class="font-weight-bold">
                    {{ detail.account_name || detail.name || '-' }}
                  </div>
                </b-col>
                <b-col cols="6" v-if="activeTab == 'active'">
                  <small>Customer ID</small>
                  <div class="font-weight-bold">
                    {{ detail.customer_code || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Customer Status</small>
                  <div class="font-weight-bold text-capitalize">
                    {{ detail.customer_status || detail.status || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Customer Class</small>
                  <div class="font-weight-bold">
                    {{
                      detail.customer_class?.name ||
                      detail.customer_class ||
                      'DEFAULT'
                    }}
                  </div>
                </b-col>
              </b-row>

              <div class="section-title my-3">
                <h6>ACCOUNT ADDRESS</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Country</small>
                  <div class="font-weight-bold">
                    {{ detail.country || detail.country_id || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Provience</small>
                  <div class="font-weight-bold">
                    {{ detail.province || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>City</small>
                  <div class="font-weight-bold">{{ detail.city || '-' }}</div>
                </b-col>
                <b-col cols="6">
                  <small>District</small>
                  <div class="font-weight-bold">
                    {{ detail.district || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Sub District</small>
                  <div class="font-weight-bold">
                    {{ detail.sub_district || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Postal Code</small>
                  <div class="font-weight-bold">
                    {{ detail.postal_code || '-' }}
                  </div>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <small>Address</small>
                  <div class="font-weight-bold=">
                    {{ detail.address || '-' }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <div class="section-title mb-3">
                <h6>ADDITIONAL ACCOUNT INFO</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Website</small>
                  <div class="font-weight-bold">{{ detail.web || '-' }}</div>
                </b-col>
                <b-col cols="6">
                  <small>Fax</small>
                  <div class="font-weight-bold">{{ detail.fax || '-' }}</div>
                </b-col>
                <b-col cols="6">
                  <small>Assistant</small>
                  <div class="font-weight-bold">
                    {{ detail.assistance || '-' }}
                  </div>
                </b-col>
              </b-row>
              <div class="section-title my-3">
                <h6>PRIMARY CONTACT</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Name</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_name || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Job Title</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_job_title || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Email</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_email || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Phone 1</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_phone || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Mobile Phone 1</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_mobile_phone || '-' }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <!-- BILLING -->
        <div v-else-if="detailActiveTab === 'billing'" class="mt-4">
          <b-row>
            <b-col md="6">
              <div class="section-title mb-3">
                <h6>BILL TO ADDRESS</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Country</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_country || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Provience</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_province || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>City</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_city || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>District</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_district || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Sub District</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_sub_district || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Postal Code</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_postal_code || '-' }}
                  </div>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <small>Address</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.bill_address || '-' }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <div class="section-title mb-3">
                <h6>BILL TO INFO</h6>
              </div>
              <b-row>
                <b-col cols="6">
                  <small>Account Name</small>
                  <div class="font-weight-bold">
                    {{ detail.primary_name || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Attention</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.attention || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Business 1</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.business_1 || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Business 2</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.business_2 || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Business 3</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.business_3 || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Fax</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.fax || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Home</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.home || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Home Fax</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.home_fax || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Email</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.email || '-' }}
                  </div>
                </b-col>
                <b-col cols="6">
                  <small>Web</small>
                  <div class="font-weight-bold">
                    {{ firstBilling.web || '-' }}
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <!-- CONTACT -->
        <div v-else-if="detailActiveTab === 'contact'" class="mt-4">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Job Title</th>
                  <th>Email</th>
                  <th>Mobile Phone</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(c, i) in detail.contacts || detail.contact || []"
                  :key="i"
                >
                  <td>{{ c.name || '-' }}</td>
                  <td>{{ c.department || '-' }}</td>
                  <td>{{ c.job_title || c.jobTitle || '-' }}</td>
                  <td>{{ c.email || '-' }}</td>
                  <td>{{ c.mobile_phone || c.mobile || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- DOCUMENT -->
        <div v-else class="mt-4">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Document Name</th>
                  <th>Document Upload</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, idx) in detail.documents || []" :key="idx">
                  <td>{{ d.document_name || d.name }}</td>
                  <td>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      :disabled="!d.file_path"
                    >
                      <i class="fa fa-download"></i>
                      Download
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </custom-sidebar>
  </b-row>
</template>

<script>
import { fleetsActions, pmsActions } from '@/src/Utils/helper'
import CustomNav from '@/src/components/global/CustomNav.vue'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import hmacClient from '@/src/services/hmacClient'
import FormCustomerNew from '../components/FormCustomerNew.vue'

export default {
  name: 'VendorNew',
  components: { CustomSidebar, CustomNav, FormCustomerNew },
  data() {
    return {
      showDetail: false,
      detail: {},
      detailTabs: [
        { label: 'General', value: 'general' },
        { label: 'Billing', value: 'billing' },
        { label: 'Contact', value: 'contact' },
        { label: 'Support Document', value: 'document' },
      ],
      detailActiveTab: 'general',
      tabs: [
        {
          label: 'Customer Active',
          value: 'active',
        },
        {
          label: 'Customer Prospect',
          value: 'prospect',
        },
      ],
      activeTab: 'active',
      showModalImport: false,
      importFile: null,
      showModalFilter: false,
      limitOptions,
      typeFleet: [],
      equipmentParents: [],
      showSidebar: false,
      isLoading: false,
      searchTimeout: null,
      equipment: {
        editMode: false,
        params: {
          search: '',
          vehicleTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
        },
        prospectParams: {
          search: '',
          vehicleTypeIds: [],
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
        },
        data: [],
        form: {
          maintenance_component_id: null,
          equipment_name: '',
          description: '',
          vehicleTypeId: [],
          active: true,
        },
        detailData: null,
      },
      listCustomerProspect: [],
      listCustomerActive: [],
    }
  },
  methods: {
    showDetailCustomer(item, isProspect = false) {
      // Normalize object fields for detail view
      this.detailActiveTab = 'general'
      this.detail = {
        ...item,
        contacts: item.contacts || item.contact || [],
        documents: item.documents || [],
        billings: item.billings || item.billing || [],
      }
      this.showDetail = true
    },
    ...fleetsActions,
    ...pmsActions,
    async fetchCustomers() {
      try {
        const param = {
          ...this.equipment.params,
        }
        console.log(param, 'param')
        this.isLoading = true
        const response = await hmacClient.get('/customers', {
          params: param,
        })
        this.listCustomerActive = response.data.result
        this.equipment = {
          ...this.equipment,
          params: {
            ...this.equipment.params,
            total: response.data.totalRows,
            totalPages: response.data.totalPage,
          },
        }
      } catch (error) {
        return error
      } finally {
        this.isLoading = false
      }
    },
    async fetchCustomerProspects() {
      try {
        this.isLoading = true
        const response = await hmacClient.get('/busdev/customer-prospects', {
          params: this.equipment.prospectParams,
        })
        console.log(response, 'RESSS????')
        this.listCustomerProspect = response.result || []
        this.equipment = {
          ...this.equipment,
          prospectParams: {
            ...this.equipment.prospectParams,
            total: response.totalRows || this.listCustomerProspect.length,
            totalPages: response.totalPage || 1,
          },
        }
      } catch (error) {
        return error
      } finally {
        this.isLoading = false
      }
    },
    async handleImport() {
      try {
        // const formData = new FormData()
        // formData.append('file', this.importFile)
        // const res = await this.importEquipment(formData)
        // this.$swal({
        //   title: 'Import Data Success',
        //   icon: 'success',
        // })
      } catch (error) {
        this.$swal({
          title: 'Failed Import Data!',
          type: 'error',
          text: 'Failed Import Data please check your file import!',
          icon: 'error',
        })
      } finally {
        // Import completed
      }
    },
    async handleExport() {
      try {
        // Download template for customer prospects import using secured HMAC API
        const response = await hmacClient.get(
          '/busdev/customer-prospects/import/template',
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'customer_prospects_template.xlsx'
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)

        this.$swal({
          title: 'Download Template Success',
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          text: error?.message || 'Unable to download template',
          icon: 'error',
        })
      }
    },
    async exportData() {
      try {
        // Build params from current active tab
        const params =
          this.activeTab === 'active'
            ? { ...this.equipment.params }
            : { ...this.equipment.prospectParams }

        // Normalize array params into comma-separated strings
        if (Array.isArray(params.vehicleTypeIds)) {
          params.vehicleTypeIds = params.vehicleTypeIds.join(',')
        }

        // Remove pagination for export to fetch all filtered data unless API uses it
        delete params.page
        delete params.limit

        // Choose endpoint: prospect uses busdev export path
        const path =
          this.activeTab === 'active'
            ? '/export-customers'
            : '/busdev/customer-prospects/export'

        // Use updated hmacClient with blob responseType
        const response = await hmacClient.get(path, {
          params,
          responseType: 'blob'
        })

        if (!response || !response.data) {
          throw new Error('No data received from export')
        }


        const blob = response.data
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        
        const contentDisposition = response.headers['content-disposition']
        const filename = contentDisposition 
          ? contentDisposition.split('filename=')[1]?.replace(/"/g, '')
          : this.activeTab === 'active'
            ? 'customers.xlsx'
            : 'customer_prospects.xlsx'
        
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        this.$bvToast &&
          this.$bvToast.toast('Export completed successfully', { variant: 'success' })
      } catch (error) {
        console.error('Export failed:', error)
        this.$swal({ 
          title: 'Export Failed', 
          text: error.message || 'An error occurred during export',
          icon: 'error' 
        })
      }
    },
    openSidebar(data) {
      this.showSidebar = true
      if (data) {
        this.equipment.editMode = true
        this.equipment.detailData = data
        this.equipment.form = {
          maintenance_component_id: data.maintenance_component_id,
          equipment_name: data?.equipment_name,
          description: data.description,
          vehicle_type_ids: data.maintenance_component_vehicle_types?.map(
            (el) => el?.vehicle_type_id
          ),
          active: data.active,
        }
      } else {
        this.equipment.editMode = false
        this.equipment.detailData = null
        this.equipment.form = {
          maintenance_component_id: null,
          equipment_name: '',
          description: '',
          vehicle_type_ids: [],
          active: true,
        }
      }
    },

    openEditCustomer(item) {
      // Open sidebar with edit mode and selected item
      this.equipment.editMode = true
      this.equipment.detailData = item
      this.showSidebar = true
    },

    closeProspectPopover(i) {
      // Deterministically close popover by toggling target and removing focus
      try {
        const id = `popover-action-prospect-${i}`
        const btn = document.getElementById(id)
        if (btn) {
          btn.blur()
          btn.click()
        }
      } catch (e) {
        /* noop */
      }
    },

    async afterFormSubmit() {
      // Refresh prospects after submit
      if (this.activeTab === 'prospect') {
        await this.fetchCustomerProspects()
      } else {
        await this.fetchCustomers()
      }
    },

    closeSidebar() {
      this.showSidebar = false
    },

    handlePageChange(page) {
      if (this.activeTab === 'active') {
        this.equipment.params.page = page
        this.fetchCustomers()
      } else {
        this.equipment.prospectParams.page = page
        this.fetchCustomerProspects()
      }
    },

    handleLimitChange() {
      if (this.activeTab === 'active') {
        this.equipment.params.page = 1 // Reset to first page when changing limit
        this.fetchCustomers()
      } else {
        this.equipment.prospectParams.page = 1 // Reset to first page when changing limit
        this.fetchCustomerProspects()
      }
    },

    handleSearchInput() {
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        if (this.activeTab === 'active') {
          this.equipment.params.page = 1 // Reset to first page when searching
          this.fetchCustomers()
        } else {
          this.equipment.prospectParams.page = 1 // Reset to first page when searching
          this.fetchCustomerProspects()
        }
      }, 500) // Wait 500ms after user stops typing
    },

    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async handleSubmit() {
      if (this.equipment.form.maintenance_component_id) {
        this.equipment.form.maintenance_component_id = Number(
          this.equipment.form.maintenance_component_id
        )
      }

      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        },
      })

      if (this.equipment.editMode) {
        const res = await this.updateEquipment({
          id: this.equipment.detailData.id,
          data: this.equipment.form,
        })
        if (res.status === 'success') {
          this.$swal('Update Success!', res.data.message, 'success')
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const body = {
          ...this.equipment.form,
          alias: this.equipment.form.equipment_name
            .toLowerCase()
            .replace(' ', '_'),
        }
        const res = await this.createEquipment(body)
        if (res.status === 'success') {
          this.$swal('Add Success!', res.data.message, 'success')
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    deleteItem(dataVal) {
      this.$swal({
        title: 'Delete Equipment Category?',
        text: `${dataVal.text} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteEquipment(dataVal.id)
          if (res.status === 'success') {
            this.$swal(
              `Deleted!`,
              `Equipment Category ${dataVal.equipment_name} successfully deleted`,
              'success'
            )
          } else {
            this.$swal('Error', res.data.message || 'Server error', 'error')
          }
        }
      })
    },
    getContactValue(contact, key) {
      if (contact?.length === 0 || !key) return '-'
      return contact[0][key]
    },
  },
  computed: {
    firstBilling() {
      const arr = this.detail?.billings || []
      return Array.isArray(arr) && arr.length ? arr[0] : {}
    },
    currentPage: {
      get() {
        return this.activeTab === 'active' 
          ? this.equipment.params.page 
          : this.equipment.prospectParams.page
      },
      set(value) {
        if (this.activeTab === 'active') {
          this.equipment.params.page = value
        } else {
          this.equipment.prospectParams.page = value
        }
      }
    },
    currentLimit: {
      get() {
        return this.activeTab === 'active' 
          ? this.equipment.params.limit 
          : this.equipment.prospectParams.limit
      },
      set(value) {
        if (this.activeTab === 'active') {
          this.equipment.params.limit = value
        } else {
          this.equipment.prospectParams.limit = value
        }
      }
    },
  },
  watch: {
    // When tab changes, reset filters and refetch data
    activeTab(newVal) {
      if (newVal === 'active') {
        // reset active customers filters
        this.equipment.params = {
          ...this.equipment.params,
          search: '',
          vehicleTypeIds: [],
          page: 1,
        }
        this.fetchCustomers()
      } else if (newVal === 'prospect') {
        // reset prospect customers filters
        this.equipment.prospectParams = {
          ...this.equipment.prospectParams,
          search: '',
          vehicleTypeIds: [],
          page: 1,
        }
        this.fetchCustomerProspects && this.fetchCustomerProspects()
      }
    },
  },
  mounted() {
    this.getVehicleTypeData()
    this.fetchCustomers()
  },
  beforeDestroy() {
    // Clean up search timeout to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
}
</script>

<style scoped>
.column-1 {
  min-width: 160px;
  position: sticky;
  left: 0;
}

.column-2 {
  width: 200px;
  position: sticky;
  left: 160px;
}

.column-action {
  min-width: 160px;
  position: sticky;
  right: 0px;
}

.address-column {
  width: 240px !important;
  max-width: 240px !important;
  padding: 8px 12px;
}

.address-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  cursor: pointer;
}

.section-title {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #334697;
  background: blue;
  margin-bottom: 20px;
}

.section-title h6 {
  color: #273469;
  font-weight: 600;
  background: white;
  position: absolute;
  top: -12px;
  padding-right: 20px;
}
</style>
